<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="auth-reset-password-form mt-2">
  <div class="alert alert-info p-1">
    After reset, then password goes back to your <b>ADMISSION NUMBER</b>.<br />
    You can change it to something new after you log in.
  </div>
  <div class="form-group">
    <label>School Based Username/Phone number</label>
    <input class="form-control" [value]="checkedResetUsername" disabled />
  </div>
  <div class="form-group">
    <label>Authentication</label>
    <input
      class="form-control"
      formControlName="name"
      placeholder="Enter your full name to verify your identity"
    />
    <div
      *ngIf="resetPasswordForm.get('name').invalid && (resetPasswordForm.get('name').dirty || resetPasswordForm.get('name').touched)"
      class="text-danger"
    >
      Enter your full name to verify your identity
    </div>
  </div>
  <div *ngIf="resetPasswordError" class="alert alert-danger p-1">{{ resetPasswordError }}</div>
  <div *ngIf="resetPasswordSuccess" class="alert alert-success p-1">{{ resetPasswordSuccess }}</div>
  <button class="btn btn-primary btn-block" [disabled]="resetPasswordForm.invalid || loading">
    Reset Password
  </button>
</form>